import { Page, Pagebar, PagebarTitle } from '@monorepo/base/src/components/page/page';
import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import styles from './create-job.module.scss';
import { Fragment, useEffect, useState } from 'react';
import { PrimaryButton } from '@monorepo/base/src/components/buttons/buttons';
import { JobForm } from '../../../modules/components/forms/job/job.form';
import { observer } from 'mobx-react';
import { useLocation } from 'react-router-dom';
import { Disable } from '@monorepo/base/src/components/disable/disable';
import { BottomBar, BottomBarActions } from '@monorepo/base/src/components/bottom-bar/bottom-bar';
import { Toggle } from '@monorepo/base/src/components/form/toggle/toggle';
import { SpacerX } from '@monorepo/base/src/components/spacer/spacer';
import { DispatchLogsTypes, useLogs } from '@monorepo/controlled/src/hooks/use-logs';
import { ErrorMsg } from '../../../modules/components/error-msg/error-msg';
import { IAdminxStore } from '../../../modules/stores';
import { Statuses } from '../../../modules/enums/status';
import { DataAttribute } from '@monorepo/tools/src/lib/models/data-attr.model';
import { useNavigateParams } from '@monorepo/tools/src/lib/hooks/tools/use-navigate-params';

export const CreateJob = observer(() => {
	const { jobStore } = useStores<IAdminxStore>();
	const [isFormClicked, setFormClicked] = useState<boolean>(false);
	const { dispatchLog } = useLogs();

	const jobCrudStore = jobStore.getCrud();
	const job = jobCrudStore.getData();

	const navigate = useNavigateParams();
	const location = useLocation();

	useEffect(() => {
		jobCrudStore.reset();
	}, [location]);

	const name = jobCrudStore.getData().getName();
	const formStore = jobCrudStore.getFormStore();
	const isValidForm = formStore.getIsValid();
	const isLoading = jobCrudStore.getIsLoading();
	const isSuccess = jobCrudStore.getIsSuccess();
	const error = jobCrudStore.getHttpError();

	useEffect(() => {
		if (!isValidForm && isFormClicked) {
			dispatchLog({
				msg: 'Please complete all mandatory fields',
				type: DispatchLogsTypes.Error,
			});
		}
	}, [isFormClicked]);

	useEffect(() => {
		if (isSuccess) {
			navigate(-1);
			dispatchLog({
				msg: `Job ${name} was successfully added`,
				type: DispatchLogsTypes.Success,
			});
			jobCrudStore.setIsSuccess(false);
		}
	}, [isSuccess]);

	const onCreateJob = () => {
		setFormClicked(true);
		jobStore.getCrud().create();
	};

	return (
		<Fragment>
			<Disable is={isLoading}>
				<Page className={isLoading ? styles.loadingPage : ''}>
					<Pagebar>
						<PagebarTitle>
							<div className={styles.title}>Create job</div>
							<SpacerX />
							<Toggle
								label={job.getIsActive() === true ? Statuses.Active : Statuses.Paused}
								onChange={status => job.setIsActive(status ? true : false)}
								defaultValue={job.getIsActive() === true}
								debugProps={{ dataAttrs: [new DataAttribute('id', 'job_status')] }}
							/>
						</PagebarTitle>
					</Pagebar>
					<JobForm />
				</Page>
				<BottomBar>
					{error ? <ErrorMsg error={error} /> : null}
					<BottomBarActions>
						<PrimaryButton
							onClick={() => onCreateJob()}
							debugProps={{ dataAttrs: [new DataAttribute('id', 'create_job_button')] }}
							isRotateIcon={isLoading}
							icon={isLoading ? 'loading-01' : 'send-03'}>
							Create
						</PrimaryButton>
					</BottomBarActions>
				</BottomBar>
			</Disable>
		</Fragment>
	);
});
